import type { OpenBizChatSidePaneParams } from 'owa-bizchat-types';

// Outlook newsletter 'draft a newsletter...' prompt
const DRAFT_NEWSLETTER_CMM_ID = 'cmm8rmk98fa';

const nonExecutableCmmIds: Set<string> = new Set([
    'cmm8sfnmv2v',
    'cmmdgpzts5s',
    DRAFT_NEWSLETTER_CMM_ID,
]);
export const isNonExecutableCmmId = (formCode?: OpenBizChatSidePaneParams['formCode']): boolean => {
    return !!formCode && nonExecutableCmmIds.has(formCode);
};
